import { DOCUMENT_TYPE } from '@dealstack/shared/lib/common/file/file';
import { useEffect, useRef, useState } from 'react';
import { IDocumentViewerProps } from './DocumentViewer.types';

export const useDocumentViewerController = ({
	file,
	fileExtension,
}: {
	file: IDocumentViewerProps['file'];
	fileExtension: IDocumentViewerProps['fileExtension'];
}) => {
	const imageRef = useRef<HTMLImageElement>(null);
	const [documentType, setDocumentType] = useState<DOCUMENT_TYPE | null>(null);

	useEffect(() => {
		const fileType = fileExtension === 'pdf' ? DOCUMENT_TYPE.PDF : DOCUMENT_TYPE.IMAGE;
		setDocumentType(fileType);
	}, [imageRef, fileExtension, file]);

	useEffect(() => {
		if (documentType !== DOCUMENT_TYPE.IMAGE) {
			return;
		}
		if (typeof file === 'string') {
			return;
		}
		if (!imageRef.current) {
			return;
		}

		const imageUrl = (window.URL || window.webkitURL).createObjectURL(file as unknown as Blob);
		imageRef.current.src = imageUrl;
	}, [imageRef, documentType, file]);

	return {
		imageRef,
		documentType,
	};
};
